import { socket } from "@/api/socket";
import { LocalStorageService, queryClient } from "@/utils";
import { useRedirect } from "react-admin";

export const useSession = () => {
  const redirect = useRedirect();

  const logout = () => {
    LocalStorageService.deleteAuthTokens();
    LocalStorageService.deleteSupportAuthTokens();
    queryClient.clear();
    queryClient.cancelQueries();
    socket.disconnect();

    redirect("/login");
  };

  return { logout };
};
